import { Cell } from '@table-library/react-table-library/table';
import Action from '../../actions';
import { showPlatform } from '../../../PromptManager/keys';
import { AI_TOOLS } from '../../../configs';
import DomainImage from '../../../../../components/DomainImage';

export const COLUMNS = (totalRuns = 1, t, project, updateProject, totalMentions) => [
    {
        label: t('ai_tracking.keyword_detail.brands.columns.brand'),
        key: 'brand',
        data: 'brand',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong className="wrap-text">{data}</strong>;
        },
    },
    {
        label: t('ai_tracking.keyword_detail.brands.columns.domain'),
        key: 'domain',
        data: 'domain',
        cellSize: 'minmax(180px, 1.5fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.domain;
            return (
                <div>
                    <strong className="wrap-text d-flex align-items-center">
                        <DomainImage domain_name={item.domain} className="domain_img" />
                        <span>{item.domain}</span>
                    </strong>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.brands.columns.mentionsShare'),
        key: 'mentions_share',
        data: 'mentions_share',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => a.mentions / totalMentions - b.mentions / totalMentions),
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload)
                return item.mentions && totalMentions
                    ? `${((item.mentions / totalMentions) * 100).toFixed(2)}%`
                    : '-';
            return item.mentions && totalMentions
                ? `${((item.mentions / totalMentions) * 100).toFixed(2)}%`
                : '-';
        },
    },
    {
        label: t('ai_tracking.keyword_detail.brands.columns.mentions'),
        key: 'mentions',
        data: 'mentions',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.brands.columns.platforms'),
        key: 'platforms',
        data: 'platforms',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const platforms = data?.split(',') || [];
            return (
                <div className="d-flex flex-wrap gap-4">
                    {Object.keys(AI_TOOLS).map((state) => (
                        <div
                            key={state}
                            title={AI_TOOLS[state]}
                            className={`ai-tracking-platform-2 no-clickable  ${
                                platforms?.includes(state) ? '' : 'disabled'
                            }`}
                        >
                            {showPlatform(state)}
                        </div>
                    ))}
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.brands.columns.visibilityAvgPosition'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data }) => {
            return data?.toFixed(2) ?? '-';
        },
    },
    {
        label: t('ai_tracking.keyword_detail.brands.columns.sentiment'),
        key: 'avgSentiment',
        data: 'avgSentiment',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => Math.abs(a.avgSentiment) - Math.abs(b.avgSentiment)),
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const className = data > 0.5 ? 'positive' : data >= 0 ? 'warning' : 'negative';
            const value = Math.abs(data);
            return <span className={`ai-column ${className}`}>{value?.toFixed(2)}</span>;
        },
    },
    {
        label: '',
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.brand;
            return <Action brand={item.brand} project={project} updateProject={updateProject} />;
        },
    },
];
